<!-- <mat-card>
  <form fsForm [submit]="save">
    <app-terms-display
      [termsLabel]="'Terms of service'"
      [header]="header"
      [content]="content"
      [effectiveDate]="effectiveDate">
    </app-terms-display>

    <fs-checkbox-group
        [(ngModel)]="agreement"
        [required]="true"
        name="agreement"
        orientation="vertical">
      <mat-checkbox value="agreement">
        I agree to the terms of service
      </mat-checkbox>
    </fs-checkbox-group>

    <div>
      <button type="submit" mat-button color="primary">Continue</button>
      <button type="button" mat-button (click)="signOut()">Cancel</button>
    </div>
  </form>
</mat-card> -->
<mat-card>
  <mat-card-content>
    <app-terms-display
      [type]="'organization'"
      [header]="'terms of service · organization account'"
      [skippable]="skippable"
      (submitted)="submit()"
      (skipped)="skip()">
    </app-terms-display>
  </mat-card-content>
</mat-card>